"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWithIcon = void 0;
const react_1 = __importDefault(require("react"));
const CheckCircle_1 = __importDefault(require("@kyruus/react-ikons/CheckCircle"));
const styled_components_1 = require("../common/styles/styled-components");
exports.ButtonWithIcon = react_1.default.forwardRef((_a, ref) => {
    var { mode = 'primary', active = false, icon = react_1.default.createElement(CheckCircle_1.default, null), iconAlign = 'right', children, disabled, onClick } = _a, props = __rest(_a, ["mode", "active", "icon", "iconAlign", "children", "disabled", "onClick"]);
    const buttonProps = Object.assign(Object.assign({}, props), { active,
        iconAlign,
        disabled, onClick: disabled ? undefined : onClick, ref });
    switch (mode) {
        case 'secondary':
            return (react_1.default.createElement(styled_components_1.SecondaryButtonWithIcon, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.IconButtonContent, { active: active, iconAlign: iconAlign },
                    react_1.default.createElement("span", null, children),
                    react_1.default.createElement("span", null, icon))));
        case 'tertiary':
            return (react_1.default.createElement(styled_components_1.TertiaryButtonWithIcon, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.IconButtonContent, { active: active, iconAlign: iconAlign },
                    react_1.default.createElement("span", null, children),
                    react_1.default.createElement("span", null, icon))));
        case 'quaternary':
            return (react_1.default.createElement(styled_components_1.QuaternaryButtonWithIcon, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.IconButtonContent, { active: active, iconAlign: iconAlign },
                    react_1.default.createElement("span", null, children),
                    react_1.default.createElement("span", null, icon))));
        case 'flat':
            return (react_1.default.createElement(styled_components_1.FlatButtonWithIcon, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.IconButtonContent, { active: active, iconAlign: iconAlign },
                    react_1.default.createElement("span", null, children),
                    react_1.default.createElement("span", null, icon))));
        case 'floating-primary':
            return (react_1.default.createElement(styled_components_1.FloatingPrimaryButtonWithIcon, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.IconButtonContent, { active: active, iconAlign: iconAlign },
                    react_1.default.createElement("span", null, children),
                    react_1.default.createElement("span", null, icon))));
        case 'ghost':
            return (react_1.default.createElement(styled_components_1.GhostButtonWithIcon, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.IconButtonContent, { active: active, iconAlign: iconAlign },
                    react_1.default.createElement("span", null, children),
                    react_1.default.createElement("span", null, icon))));
        case 'contrast':
            return (react_1.default.createElement(styled_components_1.ContrastButtonWithIcon, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.IconButtonContent, { active: active, iconAlign: iconAlign },
                    react_1.default.createElement("span", null, children),
                    react_1.default.createElement("span", null, icon))));
        case 'primary':
        default:
            return (react_1.default.createElement(styled_components_1.PrimaryButtonWithIcon, Object.assign({}, buttonProps),
                react_1.default.createElement(styled_components_1.IconButtonContent, { active: active, iconAlign: iconAlign },
                    react_1.default.createElement("span", null, children),
                    react_1.default.createElement("span", null, icon))));
    }
});
exports.ButtonWithIcon.displayName = 'ButtonWithIcon';
//# sourceMappingURL=ButtonWithIcon.js.map